import React from 'react';

const Terms = () => {
  return (
    <div className="page-container">
      <div className="container">
        <h1>Terms of Service</h1>
        <div className="legal-content">
          <p className="last-updated">Last Updated: April 2025</p>
          
          <h2>1. Acceptance of Terms</h2>
          <p>
            These Terms & Conditions (“Terms”) govern your use of InstantResumeAI’s Service. 
            By registering or using the Service, you agree to these Terms.
          </p>
          
          <h2>2. Service Description</h2>
          <p>
            <b>Free Trial:</b> 7 days of full access to Standard features. <br />
            <br />
 
              <b>Paid Tiers:</b> Standard, Elite and Pro—each with varying enhancement limits and priority support. <br />
              <br />
  
            Subscriptions renew automatically until canceled.
          </p>
          
          <h2>3. User Responsibilities</h2>
          <p>
              You must provide accurate registration information.
 
              You are responsible for safeguarding your password and activity under your account.
          </p>
          
          <h2>4. Intellectual Property</h2>
          <p>
            All fees are billed via Stripe at the start of each billing cycle. <br />
            <br />
 
            No refunds after the 7-day trial, except as required by law. <br />
            <br />
  
            Failed payments may result in suspended access until resolved.
          </p>
          
          <h2>5. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, InstantResumeAI’s liability for any claim arising out of or relating to these Terms or the Service is limited to the amount you paid us in the 12 months preceding the claim. 
            We are not liable for indirect, incidental or consequential damages.
          </p>
          
          <h2>6. Contact Information</h2>
          <p>
            For questions about these Terms of Service, please contact us at info@instantresumeai.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;